<template>
  <Button
    class="bttn-AJ autorization-personal-register"
    :label="appState$$.isLogged ? `Registro de solicitud` : `Datos personales`"
    tabindex="0"
    @click="goToRegister"
    @keyup.enter="goToRegister"
  />
</template>

<script setup>
// #region Vue
import {
  inject,
  computed,
} from 'vue';
// #endregion

// #region Sttedra
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

// #region Components
import Button from 'primevue/button/sfc';
// #endregion

// #region Composables
import {useRouter} from 'vue-router';
import {useStore} from 'vuex';
import {useDebounceFn} from '@vueuse/core';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const router = useRouter();
const store = useStore();
const appState$$ = inject('appState$$');

const isTutorizeMode = computed(() => store.getters['register/isTutorizeMode']);

const REGISTER_ROUTE_NAME = computed(() =>
  isTutorizeMode.value ? 'RegisterTutorize' : 'Register',
);
const DEBOUNCE_DELAY = 200; // milliseconds
const DEBOUNCE_MAX_WAIT = 700; // milliseconds
// #endregion

// #region Functions
/**
 * Navigates to the Register route.
 *
 * This function is debounced to prevent rapid successive calls.
 */
const goToRegister = useDebounceFn(goToRegisterFn, DEBOUNCE_DELAY, {maxWait: DEBOUNCE_MAX_WAIT});

/**
 * Function to navigate to the Register route.
 *
 * @throws Will log an error if navigation fails.
 */
function goToRegisterFn() {
  try {
    const routeData = {};
    router.push({
      name: REGISTER_ROUTE_NAME.value,
      ...routeData,
    });
  } catch (error) {
    useDev.error('[Autorization.vue] goToRegister', error);
  }
}
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
.autorization-personal-register{
  width: auto !important;
  height: 50px !important;
  background-color: var(--primary-800) !important;
}
</style>
